/* eslint-disable camelcase */
import React, { useContext, useEffect, useMemo } from 'react';
import { abTestDataContext, AFTER_FIVE_ORDERS } from 'app/containers/contexts/abTest.context';
import { useRefferalUserState } from './useRefferalUserState';

export const useBR1201ABData = (testName = AFTER_FIVE_ORDERS) => {
    const { canShareReferralLink, user_ID } = useRefferalUserState();
    const {
        fetchABTestValue,
        setABTestValue,
        ...otherState
    } = useContext(abTestDataContext);

    const isTestUnfetched = useMemo(
        () => otherState[testName] === 'unfetched',
        [testName, otherState],
    );

    /**
     * @description
     */
    useEffect(() => {
        if (canShareReferralLink && isTestUnfetched) {
            const cachedTestValue = sessionStorage.getItem(testName);
            if (cachedTestValue) {
                console.log(testName, 'cached', cachedTestValue);
                setABTestValue(testName, cachedTestValue);
            } else {
                console.log(testName, 'fetch');
                fetchABTestValue(testName);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [setABTestValue, canShareReferralLink, fetchABTestValue, testName, isTestUnfetched]);
};
